import { useEffect } from 'react';
import { useRevalidator, useRouteError } from 'react-router-dom';

import { getObservabilityContext, reportBrowserError } from '@/observability';
import { isKycRouteError } from '@/routes/kycError';

import { ErrorScreen, ErrorView } from './ErrorPage';

export default function KycErrorPage() {
  const error = useRouteError();
  const revalidator = useRevalidator();
  const kycError = isKycRouteError(error) ? error : undefined;

  useEffect(() => {
    if (kycError) reportBrowserError('route', kycError, { routeArea: 'onboarding' });
  }, [kycError]);

  if (!kycError) return <ErrorView error={error} source='route' />;

  const reference = getObservabilityContext().correlationId;
  if (kycError.code === 'invalid-link') {
    return (
      <ErrorScreen
        message='Return to Alphie Trader to start onboarding again or request a new link.'
        reference={reference}
        showHome
        title='This onboarding link is invalid or has expired'
      />
    );
  }

  return (
    <ErrorScreen
      actionDisabled={revalidator.state === 'loading'}
      actionLabel={revalidator.state === 'loading' ? 'Retrying…' : 'Retry'}
      message='Check your connection and try again.'
      onAction={() => revalidator.revalidate()}
      reference={reference}
      showHome
      title='Unable to load onboarding'
    />
  );
}
